import { useEventTimezoneQuery } from '@graphql/generated';
import { useEventInfo } from '@shared/utils/eventInfo';

export const formatDateAsISO8601TZ = (date: Date | null, timezone?: string) => {
  if (!date) {
    return null;
  }

  return timezone ? `${date.toISOString()}[${timezone}]` : date.toISOString();
};

export const split86012String = (isoString: string) => {
  const [datetimeRaw, zonePart] = isoString.split('[');

  if (!zonePart) {
    return { datetime: new Date(datetimeRaw), timezone: undefined };
  }

  const timezone = zonePart.replace(']', '');
  const datetime = new Date(datetimeRaw);

  return { datetime, timezone };
};

export const useGetEventTimezone = (): string | undefined => {
  const { data } = useEventTimezoneQuery({
    variables: { eventId: useEventInfo().eventInfo?.eventId ?? '' },
    batchMode: 'fast',
  });

  return data?.eventById?.info.timezone ?? undefined;
};
